import * as Sentry from '@sentry/browser';

class NetworkError extends Error {
  constructor(error, store) {
    super();

    this.name = 'NetworkError';
    this.message = 'Что-то не так с сервером. Пожалуйста, попробуйте позже';
    this.devMessage = 'API Server is not responding';
    this.status = 500;
    this.code = 500;

    store.commit('global/setAlertError', {
      state: true,
      message: this.message,
    });

    Sentry.configureScope((scope) => {
      scope.setLevel('fatal');
    });

    Sentry.captureException(error);
  }
}

export default NetworkError;
